var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHapiId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: "100%",
    viewBox: "0 0 191 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3333 63.5443C16.3333 45.997 30.511 31.7722 48 31.7722L143 31.7722C160.489 31.7722 174.667 45.997 174.667 63.5443V117.218C174.667 125.645 171.33 133.726 165.392 139.685L155.554 149.555C149.615 155.513 141.561 158.861 133.162 158.861H48C30.511 158.861 16.3333 144.636 16.3333 127.089V63.5443ZM48 47.6582C39.2555 47.6582 32.1666 54.7707 32.1666 63.5443V127.089C32.1666 135.862 39.2555 142.975 48 142.975L133.162 142.975C137.362 142.975 141.389 141.301 144.358 138.322L154.196 128.451C157.165 125.472 158.833 121.432 158.833 117.218V63.5443C158.833 54.7707 151.744 47.6582 143 47.6582L48 47.6582ZM55.9166 126.693C51.5298 126.693 47.9736 123.137 47.9736 118.75V71.25C47.9736 66.8632 51.5298 63.307 55.9166 63.307C60.3035 63.307 63.8597 66.8632 63.8597 71.25L63.8597 118.75C63.8597 123.137 60.3035 126.693 55.9166 126.693ZM79.6403 118.75C79.6403 120.857 80.4771 122.877 81.9667 124.367C83.4563 125.856 85.4767 126.693 87.5833 126.693H127.167C129.273 126.693 131.294 125.856 132.783 124.367L140.7 116.45C142.19 114.96 143.026 112.94 143.026 110.833V79.1667V71.25C143.026 66.8632 139.47 63.307 135.083 63.307H87.5833C83.1965 63.307 79.6403 66.8632 79.6403 71.25L79.6403 118.75ZM123.877 110.807H95.5264V79.1931H127.14L127.14 107.543L123.877 110.807Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHapiId);
export default __webpack_public_path__ + "static/media/hapi-id.29de4ae64b0b33dee356af6fec84b28a.svg";
export { ForwardRef as ReactComponent };